import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SessionService } from "@services/session.service";
import { Location } from "@angular/common";
import { LicenciaService } from "@services/licencia.service";
import { BaseFuncionalidadComponent } from "@shared/base/base-funcionalidad.component";
import { Archivo } from "@models/archivo.model";
import { StateService } from "@services/state.service";
import { TipoDocumento } from "@models/tipo-documento.model";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { base64DataUrlToBlob } from "@shared/utils/base64toBlob.utils";
import { TerminologiaService } from "@services/terminologia.service";
import { Mensajes } from "@shared/enums/mensajes.enum";
import { ErrorService } from "@services/error.service";
import IMotivo from "@models/motivo.interface";
import { DocumentoService } from "@services/documento.service";
import { EstadoDocumentoLicencia } from "@shared/enums/estado-documento-licencia.enum";
import { ExpedienteEstados } from '@shared/enums/expediente-estados.enum';

@Component({
  selector: "app-ver-documento",
  templateUrl: "./ver-documento.component.html",
  styleUrls: ["./ver-documento.component.scss"],
})
export class VerDocumentoComponent extends BaseFuncionalidadComponent {
  constructor(
    sessionService: SessionService,
    route: ActivatedRoute,
    router: Router,
    location: Location,
    stateService: StateService,
    private errorService: ErrorService,
    private terminologiaService: TerminologiaService,
    private licenciaService: LicenciaService,
    private sanitizer: DomSanitizer,
    private documentoService: DocumentoService
  ) {
    super(route, sessionService, location, router, stateService);
  }

  isLoading = false; // Variable que maneja el renderizado del spinner de carga inicial
  expedienteEstados = ExpedienteEstados;
  mostrarModal = false; // Variable que maneja el renderizado del modal
  mensajeExito: string = ""; // Mensaje de éxito al validar el documento
  motivosSeleccionados: number[] = [];
  urlTemporal: SafeResourceUrl; // Variable que guarda la url temporal del documento cargado
  isPDF: boolean = false; // Variable que maneja si el documento es un pdf
  documentoCargado: Archivo;
  tiposDocumentosLicencia: TipoDocumento[] = [];
  rutaTipoDocumento: any | null = "";
  codigoEstado: Number = this.documento?.estado?.codigo;
  motivosRechazoDocumento: IMotivo[];

  async ngOnInit() {
    try {
      this.isLoading = true;
      this.expediente = this.stateService.getExpediente();
      console.log('Expediente cargado en VerDocumentoComponent:', this.expediente);
      this.isPDF = this.documento.extension === "pdf";
      this.urlTemporal = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.documento.url_documento
      );
      this.tiposDocumentosLicencia = this.terminologiaService.obtenerTiposDocumentoLicencia();
      this.rutaTipoDocumento = this.tiposDocumentosLicencia.find(td => td.codigo === this.tipoDocumento.codigo).ruta;
      this.motivosRechazoDocumento = this.terminologiaService.obtenerMotivosRechazoDocumento();

      // Determina que marca el radio button de validación del documento segun el estado retornado.
      switch (this.codigoEstado) {
        case EstadoDocumentoLicencia.ingresada:
          this.motivosSeleccionados = this.motivosRechazoDocumento.map((m: IMotivo) => m.codigo);
          break;
        case EstadoDocumentoLicencia.no_valida:
          const documentoMRE = await this.documentoService.obtenerDocumentoMRE(this.documento.id);
          this.motivosSeleccionados = documentoMRE.data.filter(m => m.ldm_id).map(m => m.mre_codigo);
          break;
      }
    } catch (error) {
      this.errorService.handle(
        error,
        "Error al cargar la información del documento"
      );
    } finally {
      this.isLoading = false;
    }
  }

  get mensajeSinPermisos(): string {
    return this.terminologiaService.obtenerMensajePorID(
      Mensajes.sin_permisos_funcionalidad
    );
  }

  get mensajeValidarDocumento(): string {
    return this.terminologiaService.obtenerMensajePorID(
      Mensajes.validar_documento
    );
  }

  get documentoValido(): boolean {
    return this.motivosSeleccionados.length === 0;
  }

  abrirModal() {
    this.mostrarModal = true;
  }

  onModalConfirmacionCerrado() {
    this.mostrarModalConfirmacion = false;
    this.volverAtras(); // Vuelve atras al cerrar el modal de confirmación
  }

  onMotivoChange(checked: boolean, codigo: number) {
    if (checked) {
      if (!this.motivosSeleccionados.includes(codigo)) {
        this.motivosSeleccionados = [...this.motivosSeleccionados, codigo];
      }
    } else {
      this.motivosSeleccionados = this.motivosSeleccionados.filter(
        (c) => c !== codigo
      );
    }
  }

  async validarDocumento() {
    this.isLoadingModal = true; // Muestra el spinner de carga del modal
    try {
      const msg = await this.licenciaService.guardarValidacionDocumento(
        this.documento.id,
        this.documentoValido ? "SI" : "NO",
        this.motivosSeleccionados.join(",")
      );
      this.mensajeExito = msg;
      this.mostrarModal = false;
      this.mostrarModalConfirmacion = true; // Encadena el modal de confirmación tras aceptar
    } catch (error) {
      this.errorService.handle(error, "Error al validar el documento");
    } finally {
      this.isLoadingModal = false; // Oculta el spinner de carga del modal
    }
  }

  goSubirDocumento() {
    this.router.navigate(["reemplazar"], {
      relativeTo: this.route,
    });
  }

  abrirEnNuevaPestana() {
    if (this.documento.url_documento) {
      let base64 = this.documento.url_documento;
      const blobUrl = base64DataUrlToBlob(base64);
      window.open(blobUrl, "_blank");
    }
  }

  asignarDocumento(file: Archivo) {
    file.tipo = this.tipoDocumento;
    this.documentoCargado = file;
    this.isPDF = this.documentoCargado?.mime === "application/pdf";
  }

  get estadoExpediente() {
    return this.expediente?.estado;
  }

  obtenerUrlTemporal(url: SafeResourceUrl) {
    this.urlTemporal = url;
  }
}
